import type Stripe from 'stripe';

export const convertCurrency = (amount: number) => {
  const dollars = amount.toLocaleString('en-AU', {
    style: 'currency',
    currency: 'AUD'
  });
  return dollars;
};

export const convertDate = (date: string) => {
  const newDate = new Date(date);
  return newDate.toLocaleDateString('en-AU');
};

export const getInterval = (interval: string, count: number) => {
  if (count === 1) {
    return interval;
  }
  if (interval === 'month' && count === 3) {
    return 'quarter';
  } else if (interval === 'month' && count === 6) {
    return 'half-year';
  } else if (interval === 'month' && count === 12) {
    return 'year';
  }
  return `${count} ${interval}s`;
};

export const getPaymentFrequency = (price: Price) => {
  if (price.interval === 'month') {
    if (price.interval_count === 1) {
      return 'Per month, billed monthly';
    } else if (price.interval_count === 3) {
      return `Per month, billed quarterly`;
    }
  }
  return '';
};

export const getStripePaymentFrequency = (price: Stripe.Price) => {
  if (price?.recurring?.interval === 'month') {
    if (price?.recurring?.interval_count === 1) {
      return 'Per month, billed monthly';
    } else if (price?.recurring?.interval_count === 3) {
      return `Per month, billed quarterly`;
    }
  }
  return '';
};

export const formatPrice = (price: Stripe.Price) => {
  const unitAmount = price.unit_amount ?? 0;
  if (price?.recurring?.interval === 'month') {
    if (price?.recurring?.interval_count === 1) {
      return fractionFormatter.format(unitAmount / 100);
    } else if (price?.recurring?.interval_count === 3) {
      return fractionFormatter.format(unitAmount / 3 / 100);
    }
  }
};

export const formatPaymentMethod = (paymentMethod: Stripe.PaymentMethod) => {
  switch (paymentMethod.type) {
    case 'card': {
      return `${paymentMethod.card?.wallet?.type || ''}${paymentMethod.card?.display_brand} ****${paymentMethod.card?.last4}`;
    }
    default:
      '';
  }
};

export function getFormattedPrice(unitAmount: number, intervalCount: number) {
  const price = Math.round(unitAmount / (intervalCount || 1) / 1.1) / 100;
  const formattedPrice =
    price % 1 === 0
      ? integerFormatter.format(price)
      : fractionFormatter.format(price);
  return { price, formattedPrice };
}

export const formatGST = (price: Stripe.Price) => {
  switch (price?.tax_behavior) {
    case 'exclusive':
      return '+ GST';
    case 'inclusive':
      return 'inc. GST';
    case 'unspecified':
    default:
      return '';
  }
};

export const fractionFormatter = Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 2,
  maximumFractionDigits: 2
});
export const integerFormatter = Intl.NumberFormat('en-AU', {
  style: 'currency',
  currency: 'AUD',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0
});
